import React from "react";
import {TaggedLogger} from "../../utilities";
import {useAppSelector} from "../hooks";
import AuctionsManager from "../services/AuctionsManager";


const _logger = TaggedLogger.get('useWebcastConnect');

export default function useWebcastConnect() {

    const webcastStatusState = useAppSelector((state) => state.activeWebcast.webcastStatus.state);


    React.useEffect(() => {

        AuctionsManager.currentWebcastAuctionHandler.connect()
            .then(() => {
                _logger.debug('.useEffect[]>currentWebcastSaleHandler.connect().then()');
            })
            .catch((reason) => {
                _logger.error('.useEffect[]>currentWebcastSaleHandler.connect().catch()', reason);
            })
            .finally(() => {

            });
    }, []);


    return webcastStatusState;
}
